import React, { useState } from 'react';

const ToggleContent: React.FC<{ content: string, title: string }> = ({ content, title }) => {
  const [isContentVisible, setContentVisible] = useState(false);

  const toggleVisibility = () => {
    setContentVisible(!isContentVisible);
  };

  function formatList(input: string): JSX.Element[] {
    // Split the input string into an array of items
    const items = input.split('#');
    
    // Map each item to a JSX element with <br> and -
    const formattedList = items.map((item, index) => (
      <React.Fragment key={index}>
        {index >= 0 && <><br />-</>}
        {item}
      </React.Fragment>
    ));
  
    return formattedList;
  }

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={toggleVisibility}>
        <span style={{ marginRight: '8px' }}>{isContentVisible ? '▼' : '►'}</span>
        <span>{title}</span>
      </div>
      {isContentVisible && <div><p className="subscription-description">{formatList(content)}</p></div>}
    </div>
  );
};

export default ToggleContent;